/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TenantQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("TenantQueryOperator");
    }

    getFixupPrototypeFunction() { return TenantQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<TenantQueryOperator>): TenantQueryOperator {
        let obj = Object.assign(new TenantQueryOperator(), model);
        TenantQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TenantQueryOperator>): TenantQueryOperator {
        if (!model) return null;
        return TenantQueryOperator.newInstance(<TenantQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TenantQueryOperator) {
        if (!obj) return;

        models.TenantQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TenantQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, TenantQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Tenants to include
     */
    tenant_ids: Array<string>;

}
